<template>
  <v-container class="content">
    <LoginLogo />

    <v-row no-gutters justify="center" align="center" class="text-center mb-4">
      <h1>{{ $t('routes.unsupportedPremiereVersion.title') }}</h1>
    </v-row>

    <v-row no-gutters justify="center" align="center" class="text-center mb-3">
      {{ $t('routes.unsupportedPremiereVersion.message', { version: minimumSupportedVersion }) }}
    </v-row>

    <v-row no-gutters justify="center" align="center" class="text-center">
      {{ $t('routes.unsupportedPremiereVersion.detectedVersion', { version: detectedVersion }) }}
    </v-row>
  </v-container>
</template>

<script>
import Helper from '@/components/helper.js';
import LoginLogo from '../account/components/LoginLogo.vue';

export default {
  name: 'UnsupportedPremiereVersionPage',
  components: {
    LoginLogo,
  },
  computed: {
    detectedVersion: function() {
      return Helper.getAdobeAppVersion() || this.$t('routes.unsupportedPremiereVersion.unknownVersion');
    },
    minimumSupportedVersion: function() {
      return Helper.getMinimumSupportedPremiereProVersion();
    },
  },
}
</script>
